import type { City, Country, Location, Province } from '@interfaces/location.interface';

import { mockDb } from '../mock-db';

export function getCountriesMock(): Country[] {
  return mockDb.getCountries();
}

export function getProvincesMock(countryId?: string): Province[] {
  return mockDb.getProvinces(countryId);
}

export function getCitiesMock(provinceCode?: string): City[] {
  return mockDb.getCities(provinceCode);
}

export function getCityByIdMock(cityId: string): City | undefined {
  return mockDb.getCityById(cityId);
}

export function getLocationsByRentalIdMock(_rentalId: string): Location[] {
  return mockDb.getLocations();
}

export function getLocationByIdMock(id: string): Location | undefined {
  return mockDb.getLocationById(id);
}

export function createLocationMock(data?: Partial<Location>): Location {
  const base = mockDb.locations[0];
  return { ...base, id: `location-${Date.now()}`, ...data };
}

export function updateLocationMock(id: string, data: Partial<Location>): Location {
  const existing = mockDb.getLocationById(id);
  const base = existing ?? mockDb.locations[0];
  return { ...base, id, ...data };
}

export function deleteLocationMock(): { success: boolean } {
  return { success: true };
}

export function getAllLocationsMock(): Location[] {
  return mockDb.getLocations();
}

export function geocodeAddressMock(address: string): {
  latitude: number;
  longitude: number;
  formattedAddress: string;
} {
  return {
    latitude: 41.3851 + Math.random() * 0.01,
    longitude: 2.1734 + Math.random() * 0.01,
    formattedAddress: address || '123 Main Street, Barcelona, Spain',
  };
}

export function reverseGeocodeMock(
  _latitude: number,
  _longitude: number
): {
  address: string;
  city: string;
  province: string;
  country: string;
  zipCode: string;
} {
  return {
    address: 'Calle Principal 123',
    city: 'Barcelona',
    province: 'Barcelona',
    country: 'Spain',
    zipCode: '08001',
  };
}
